import React, { useState, useEffect } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';
import Button from 'components/CustomButtons/Button';
import { useParams } from 'react-router-dom';

//iconos
import { Add, Receipt } from '@material-ui/icons';

//tabla y card components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';

//servicios
import { wsFindBy } from 'services/WService.js';

//modal
import { Toasty, useToasty } from 'hooks/Toasty';
import ButtonDelete from 'hooks/ButtonDelete';
import { WithApp } from 'contexts/appContext';
import { Paper } from '@material-ui/core';
import { wsGet } from 'services/WService';
import ModalFilterBPartner from 'components/Tvendo/Common/ModalFilterBPartner';
import { wsCreate } from 'services/WService';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
  },
  detail: {
    display: 'flex',
    alignItems: 'center',
    '& span': {
      marginLeft: '10px',
      marginRight: '10px',
      color: '#000000bf',
      fontWeight: 'bold',
      fontSize: '15px',
    },
  },
  paper: {
    padding: '0px 11px 4px 10px',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    marginBottom: '5px',
  },
};
const useStyles = makeStyles(styles);

//columnas para llenar la tabla
const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 80 },
  { Header: 'Cód. Cliente', accessor: 'CardCode', width: 150 },
  { Header: 'Nombre cliente', accessor: 'CardName' },
  { Header: 'Correlativo ruta', accessor: 'route_order', width: 150 },
  { Header: 'Nombre Ruta', accessor: 'base_routes_description' },
  { Header: 'Dirección', accessor: 'Address2' },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

export default WithApp(function DailyCustomerPortfolioDetail(props) {
  const classes = useStyles();

  const { id } = useParams();

  const [openModalCustomer, setOpenModalCustomer] = useState(false); //Abrir modal fuera ruta
  const [openOffPortfolioModalCustomer, setOpenOffPortfolioModalCustomer] = useState(false); //Abrir modal fuera cartera
  const [notify, showNotify] = useToasty(); //notificación despues de las acciones
  const [dailyCustomerPDs, setDailyCustomerPDs] = useState([]); //constante para el listado
  const [dCPortfolio, setDCPortfolio] = useState({});
  const [customerSelect, setCustomerSelect] = useState({});

  async function getDCPortfolio() {
    let response = await wsGet('base/daily-customer-portfolio', id);
    if (response.success) setDCPortfolio(response.data);
  }

  //recargar Listado para usar en create y update
  async function loadDailyCustomerPDs() {
    let response = await wsFindBy(
      'base/daily-customer-portfolio-detail',
      'base_daily_customer_portfolio_id',
      id,
    );
    if (response.success) setDailyCustomerPDs(response.data);
  }

  async function saveDCPortfolio() {
    const data = {
      base_daily_customer_portfolio_id: id,
      base_customer_bureau_id: customerSelect.bp.base_customer_bureau_id,
      route_type: customerSelect.route_type,
    };
    let response = await wsCreate('base/daily-customer-portfolio-detail', data);
    if (response.success) {
      showNotify(response.message);
      loadDailyCustomerPDs();
    } else {
      showNotify(response.message, 'error');
    }
  }

  useEffect(() => {
    getDCPortfolio();
    loadDailyCustomerPDs();
  }, []);

  useEffect(() => {
    if (customerSelect.bp !== undefined) {
      saveDCPortfolio();
    }
  }, [customerSelect]);

  return (
    <>
      <Toasty action={notify} />
      {openModalCustomer ? (
        <ModalFilterBPartner
          open={openModalCustomer}
          setOpen={setOpenModalCustomer}
          cardType="C"
          entity="base/daily-customer-portfolio/off-route-customers"
          filterProps={{
            base_seller_id: dCPortfolio.base_seller_id,
            base_customer_portfolio_id: dCPortfolio.base_customer_portfolio_id,
            base_route_id: dCPortfolio.base_route_id,
          }}
          setBPartnerSelect={(bp) => setCustomerSelect({bp, route_type: 'F'})}
          extraFields={[
            { Header: 'Dirección', accessor: 'Address2' },
            { Header: 'Ruta', accessor: 'base_route_description' },
          ].reverse()}
        />
      ) : undefined}

      {openOffPortfolioModalCustomer ? (
        <ModalFilterBPartner
          open={openOffPortfolioModalCustomer}
          setOpen={setOpenOffPortfolioModalCustomer}
          cardType="C"
          entity="base/daily-customer-portfolio/off-portfolio-customers"
          filterProps={{
            base_seller_id: dCPortfolio.base_seller_id,
            base_customer_portfolio_id: dCPortfolio.base_customer_portfolio_id,
            base_route_id: dCPortfolio.base_route_id,
          }}
          setBPartnerSelect={(bp) => setCustomerSelect({bp, route_type: 'C'})}
          extraFields={[
            { Header: 'Dirección', accessor: 'Address2' },
            { Header: 'Ruta', accessor: 'base_route_description' },
          ].reverse()}
        />
      ) : undefined}

      <Card>
        <CardHeader icon>
          <h4 className={classes.cardIconTitle}>Listado detalles de cartera diaria</h4>
        </CardHeader>
        <CardBody>
          {/*  */}
          <AllowedGuard
            permission={ConstantPermissions.BASE_DAILY_CUSTOMER_PORTFOLIO_DETAILS_STORE}
          >
            <GridContainer style={{ marginBottom: '10px' }}>
              <GridItem xs={12}>
                <Button onClick={() => setOpenModalCustomer(true)} color="success">
                  <Add /> Agregar cliente fuera de ruta
                </Button>
                <Button onClick={() => setOpenOffPortfolioModalCustomer(true)} color="success">
                  <Add />
                  Agregar cliente fuera de cartera
                </Button>
              </GridItem>
            </GridContainer>
          </AllowedGuard>
          <GridContainer style={{ marginBottom: '15px' }}>
            <GridItem xs={12} lg={2} className={classes.detail}>
              <Paper className={classes.paper}>
                <h5>Cartera: </h5>
                <span>{dCPortfolio.base_customer_portfolio_description}</span>
              </Paper>
            </GridItem>
            <GridItem xs={12} lg={3} className={classes.detail}>
              <Paper className={classes.paper}>
                <h5>Vendedor: </h5>
                <span>{dCPortfolio.SlpName}</span>
              </Paper>
            </GridItem>
            <GridItem xs={12} lg={2} className={classes.detail}>
              <Paper className={classes.paper}>
                <h5>Mesa: </h5>
                <span>{dCPortfolio.base_bureau_description}</span>
              </Paper>
            </GridItem>
            <GridItem xs={12} lg={3} className={classes.detail}>
              <Paper className={classes.paper}>
                <h5>Día visita: </h5>
                <span>{dCPortfolio.base_visit_day_description}</span>
              </Paper>
            </GridItem>
            <GridItem xs={12} lg={2} className={classes.detail}>
              <Paper className={classes.paper}>
                <h5>Fecha: </h5>
                <span>{dCPortfolio.document_date}</span>
              </Paper>
            </GridItem>
          </GridContainer>

          <ReactTable
            excelName="Detalle-de-carteras-diarias"
            defaultWidth={1200}
            columns={columns}
            data={dailyCustomerPDs.map((dailyCustomerPD, i) => {
              return {
                num: (
                  <div className="actions-right">
                    {i + 1}
                    <AllowedGuard
                      permission={ConstantPermissions.BASE_DAILY_CUSTOMER_PORTFOLIOS_DETAIL_DELETED}
                    >
                      <ButtonDelete
                        entity="base/daily-customer-portfolio-detail"
                        id={dailyCustomerPD.id}
                        reload={loadDailyCustomerPDs}
                      />
                    </AllowedGuard>
                  </div>
                ),
                CardCode: dailyCustomerPD.CardCode,
                CardName: dailyCustomerPD.CardName,
                route_order: dailyCustomerPD.route_order,
                base_routes_description: dailyCustomerPD.base_routes_description,
                Address2: dailyCustomerPD.Address2,
                actions: '',
              };
            })}
          />
        </CardBody>
      </Card>
    </>
  );
});
